export const ServiceConfig = {
  baseAPIUrl: process.env.REACT_APP_API_URL,
  dromoLicenseKey: process.env.REACT_DROMO_LICENSE_KEY,
  tenant: {
    tenants: '/Tenants',
    tenantLogin: '/TenantLogin',
    login: '/signinexternal',
    verifyActiveUser: '/VerifyActiveUser',
    logout: '/logout',
    impersonateLogin: '/signinimpersonate',
    impersonateCodeCheck: '/impersonatecodecheck',
    getUsers: '/users/',
    licensing: '/licensing',
    updateMarketingProduct: '/updatemarketingproduct/license',
    getLoginUrl: '/GetLoginUrl',
    getLogoutUrl: '/GetLogoutUrl',
  },
  user: {
    users: '/Users',
    uniqueEmail: '/checkUniqueMail?email=',
    forgotPassword: '/forgotpassword',
    selectUser: '/getuser/',
  },
  remote: {
    remoteAccess: '/RemoteAccess',
    localToken: '/localToken',
  },
  coreProduct: {
    company: '/company',
    campaign: '/campaign',
    discountCode: '/discountCode',
    branch: '/branch',
    service: '/service',
    frequency: '/frequency',
    taxRate: '/taxRate',
    division: '/division',
    locationType: '/locationType',
    targetPest: '/targetPest',
    sources: '/source',
    landingPage: '/search/default.asp',
    employee: '/employee',
    employeeSummary: '/employee/summary',
  },
  salesFunnel: {
    salesFunnel: '/SalesFunnel',
    getSalesFunnels: '/all',
    getSingleStages: '/leadStatuses/',
    stages: '/stages',
  },
  salesTeam: {
    salesTeam: '/SalesTeam',
    getSaleTeams: '/all',
  },
  draftLead: {
    odata: '/odata/draftLeadCards',
    draftLead: '/draftLeads',
    odataExport: '/odata/ExportDrafts',
    autoReview: '/autoReview',
  },
  autoReviewSettings: {
    autoReviewSettings: '/AutoReviewSettings',
    additionalRequiredFields: '/AutoReviewSettings/additionalRequiredFields',
  },
  companyHeaderDisplaySettings: {
    companyHeaderDisplaySettings: '/CompanyHeaderDisplaySettings',
  },
  lead: {
    details: '/Details',
    lead: '/Lead',
    add: '/Add',
    product: '/LeadProduct',
    location: '/Location',
    odata: '/odata/leadCards',
    odataExport: '/odata/ExportLeads',
    hasPropertyDetails: '/HasPropertyDetails',
    missingAutoCloseRequiredFields: '/MissingAutoCloseRequiredFields',
    isCloseable: '/IsCloseable',
    companyRequiredFields: (id: number) => `/Lead/${id}/CompanyRequiredFields`,
  },
  opportunity: {
    add: '/Add',
    update: '/Update',
    opportunity: '/Opportunity',
    location: '/Location',
    product: '/OpportunityProduct',
    odata: '/odata/opportunityCards',
    odataExport: '/odata/ExportOpps',
    soldServiceAppData: '/soldService/appData',
    appData: '/appData',
    completionDetails: '/completionDetails',
    activeServices: '/activeServices',
    rejectedNote: '/rejectedNote',
    cancelActiveServices: '/cancelActiveServices',
    split: '/split',
    hasPropertyDetails: '/HasPropertyDetails',
  },
  leadOppProduct: {
    reorder: '/ReorderProducts',
  },
  role: {
    role: '/Role',
    assignment: '/RoleAssignment',
  },
  location: {
    location: '/Location',
    odata: '/odata/locationCards',
    lead: 'LeadLocation',
    opp: 'OpportunityLocation',
  },
  measureAI: {
    measureAI: '/MeasureAI',
    propertyDetails: '/propertyDetails',
  },
  filters: (
    path: 'opportunities' | 'leads' | 'locations' | 'draftLeads',
    column: string,
  ) => `/${path}/${column}/distinct`,
  billTo: {
    billTo: 'billTo',
    locations: (id: string) => `billTo/${id}/locations`,
  },
  /** D2D sales territories (WWM-17508). */
  territory: {
    territory: '/Territory',
    byId: (id: number) => `/Territory/${id}`,
    ruleUsage: (id: number) => `/Territory/${id}/rule-usage`,
    split: (id: number) => `/Territory/${id}/split`,
    performance: '/Territory/performance',
    preview: '/Territory/preview',
    merge: '/Territory/merge',
  },
  discountCode: {
    discountCode: 'discountCode',
  },
  customFields: {
    customFields: '/customField',
    leadFormSettings: '/LeadFormSettings',
    opportunityFormSettings: '/OpportunityFormSettings',
    toggleFormSettingEnabled: '/ToggleFormSettingEnabled',
    toggleFormSettingRequired: '/ToggleFormSettingRequired',
    reorderFormSettings: '/ReorderFormSettings',
  },
  entityFormSettings: {
    entityFormSettings: '/entityFormSetting',
    leadFormSettings: '/LeadSettings',
    opportunityFormSettings: '/OpportunitySettings',
  },
  automatedAssignment: {
    automatedAssignment: '/AutomatedAssignment',
    toggleRule: '/toggleRule',
    validateCoverage: '/validateCoverage',
    reorderRules: '/reorderRules',
  },
  branch: {
    soldService: {
      appData: '/soldService/appData',
    },
  },
  scheduling: {
    commit: '/commit',
    region: '/region',
    employee: '/employee',
    scheduling: '/Scheduling',
    eligibility: '/eligibility',
    getEntityAppointments: '/GetEntityAppointments',
    searchExistingAppointments: '/search/existingAppointments',
    cancelReasons: '/cancelReasons',
    appointment: '/appointment',
    search: (svcLocId: string) => `/location/${svcLocId}/search`,
  },
  activityHistory: {
    filters: '/activityHistory/filters',
    search: '/activityHistory/search',
  },
  activityTypes: {
    activityTypes: '/activityTypes',
  },
  activities: {
    activities: 'activities',
    activitySummary: 'odata/activitySummary',
    topStats: 'getTopStats',
  },
  integrations: {
    callTracking: 'CallTrackingProvider',
    webForm: {
      ctmWebform: 'webform/ctmWebform',
    },
  },
  import: {
    odata: '/odata/import',
    save: '/import/save',
    saveResults: '/import/saveResults',
    validateName: '/import/validate/name',
    downloadFile: '/import/download',
    getFilterEntries: '/import/filterEntries',
  },
  webHooks: {
    scWebHooks: '/SalesCenterWebhooks/Registration',
  },
  knockStatus: {
    knockStatus: '/KnockStatusSetting',
    history: '/KnockStatusHistory',
    locations: '/KnockStatusLocations',
    locationsNew: '/KnockStatusLocations/new',
    contactLocations: '/KnockStatusLocations/contactLocation',
  },
  calendar: {
    // SH-1408 aggregation endpoint: GET /Calendar/Events?start=&end=&skip=&take=
    events: '/Calendar/Events',
  },
}
